import { SDK_EVENTS } from '../constants/events.cnst';
import { getHTML } from '../templatemanager/base/domManager';
import { ScrollDownArrowButtons, ScrollUpArrowButtons } from '../templatemanager/tabs/automation/automation';

export const addScrollButtons = (
    hostInstance: any,
    classConstants: any,
    rootServiceInstance: any,
    config: {
        containerClass: string,
        headerClass: string,
        upArrowClass: string,
        downArrowClass: string,
        tabType: string
    }
) => {
    const data = {
        upArrowClass: config.upArrowClass,
        downArrowClass: config.downArrowClass
    };

    // Get HTML templates for scroll buttons
    let scrollUpButtonsHtml = getHTML(ScrollUpArrowButtons, data, hostInstance);
    let scrollDownButtonsHtml = getHTML(ScrollDownArrowButtons, data, hostInstance);

    const containerEle = document.querySelector(config.containerClass) as HTMLElement;
    let headerSection = hostInstance?.chatEle?.querySelector(config.headerClass);

    if (headerSection) {
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, scrollUpButtonsHtml, { event: SDK_EVENTS.SCROLL_UP_BTN, data : config });
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, scrollDownButtonsHtml, { event: SDK_EVENTS.SCROLL_DOWN_BTN, data : config });

        // Insert scroll buttons
        headerSection.parentNode.insertBefore(scrollUpButtonsHtml, headerSection.nextSibling);
        headerSection.parentNode.insertBefore(scrollDownButtonsHtml, headerSection.nextSibling);        


        // Add event listeners
        handleScrollEvents(
            containerEle,
            headerSection.parentNode,
            hostInstance,
            classConstants,
            rootServiceInstance,
            config
        );
    }
};

const handleScrollEvents = (
    containerEle: HTMLElement,
    scrollWrapper: HTMLElement,
    hostInstance: any,
    classConstants: any,
    rootServiceInstance: any,
    config: any
) => {
    // Up arrow click
    hostInstance?.eventManager?.addEventListener?.(
        `.${config.upArrowClass}`,
        'click',
        () => {
            rootServiceInstance.scrollToTop(containerEle, config.tabType, hostInstance);
        },
        scrollWrapper
    );

    // Down arrow click
    hostInstance?.eventManager?.addEventListener?.(
        `.${config.downArrowClass}`,
        'click',
        () => {
            rootServiceInstance.scrollToTillBottom(containerEle, config.tabType, hostInstance);
        },
        scrollWrapper
    );

    // Scroll event
    hostInstance?.eventManager?.addEventListener?.(
        config.containerClass,
        'scroll',
        () => {
            checkOverflow(containerEle, hostInstance, classConstants, config);
        }
    );
};

const checkOverflow = (
    containerEle: HTMLElement,
    hostInstance: any,
    classConstants: any,
    config: any
) => {
    let blockContent = hostInstance?.chatEle?.querySelector(`.${config.tabType}-block-content`);
    if (containerEle) {
        let isTopOverflowing = containerEle.scrollTop > 100;
        let isBottomOverflowing = 
            (containerEle.scrollHeight) > containerEle.clientHeight && 
            (containerEle.scrollHeight - containerEle.scrollTop - 100) > containerEle.clientHeight;
        let topArrow = blockContent.querySelector(`.${config.upArrowClass}`);
        let downArrow = blockContent.querySelector(`.${config.downArrowClass}`);        

        if (isTopOverflowing) {
            topArrow?.classList?.remove(classConstants.HIDE_ELEMENT);
        } else {
            topArrow?.classList?.add(classConstants.HIDE_ELEMENT);
        }

        if (isBottomOverflowing) {
            downArrow?.classList?.remove(classConstants.HIDE_ELEMENT);
        } else {
            downArrow?.classList?.add(classConstants.HIDE_ELEMENT);
        }
    }
};
